import { gql } from 'react-apollo';
import { full } from "../../../../graphql/fragments/faqAnswer";

export const getFaqAnswer = gql`
  query getFaqAnswer($faqAnswerId: Int!) {
    faqAnswer: faq_answer(id: $faqAnswerId) {
      ...allFaqAnswersFields
    }
  }

  ${full}
`;



// WEBPACK FOOTER //
// ./src/components/pages/faqAnswers/queries/getFaqAnswer.js